import React, { useEffect, useState } from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';

import { componentService } from '@core/js/services/component.service';
import { clsb } from '@core/js/utils/classNames.util';

import { useQueryObject } from '@interlayer/js/app/hooks/query/useQueryObject';
import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { useUpdateEffect } from '@interlayer/js/hooks/useUpdateEffect';

import { TAccordionItemProps } from './types';

import style from '../../Accordion.scss';

export const AccordionItem: React.FC<TAccordionItemProps> = ({
    id,
    title,
    opened,
    children,
    classNames = {},
    classnames = ''
}) => {
    const { p: paragraph } = useQueryObject();
    const [isShowBody, setIsShowBody] = useState(opened);
    let outherClassNames = {};

    try {
        outherClassNames = JSON.parse(classnames.replace(/'/g, '"'));
    } catch {
        outherClassNames = {};
    }

    const buildCls = clsb([style, classNames, outherClassNames]);

    useEffect(() => {
        if (!paragraph || id !== paragraph) {
            if (paragraph) {
                setIsShowBody(false);
            }

            return;
        }

        setIsShowBody(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useUpdateEffect(() => {
        if (!paragraph || id !== paragraph) {
            return;
        }

        setIsShowBody(true);
    }, [id, paragraph]);

    return (
        <div
            id={id}
            className={clsx(buildCls(['item']), { [style.isShow]: isShowBody })}
        >
            <div
                data-testid="AccordionItem_header"
                className={buildCls(['titleWrap'])}
                onClick={() => setIsShowBody(!isShowBody)}
            >
                <div className={buildCls(['title'])}>
                    {title}
                </div>

                <SvgIcon
                    height="1.1rem"
                    width="1.2rem"
                    type="arrow-down"
                    className={buildCls(['arrow'])}
                />
            </div>

            <div
                data-testid="AccordionItem_body"
                className={buildCls(['body'])}
            >
                {children}
            </div>
        </div>
    );
};

componentService.registerWebContentComponents({ AccordionItem });
